// Phase 20 · Community V3 · Upcoming events widget (for feed/group sidebars)
import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Calendar, Radio } from "lucide-react";

const API = process.env.REACT_APP_BACKEND_URL;

export default function UpcomingEventsWidget({ limit = 5 }) {
    const [items, setItems] = useState([]);
    const [enabled, setEnabled] = useState(true);

    useEffect(() => {
        (async () => {
            try {
                const r = await fetch(`${API}/api/community/events/upcoming?limit=${limit}`, { credentials: "include" });
                if (r.status === 503) { setEnabled(false); return; }
                if (r.ok) { const d = await r.json(); setItems(d.items || []); }
            } catch {}
        })();
    }, [limit]);

    if (!enabled) return null;

    return (
        <div className="bg-[#111111] border border-[#1A1A1A] rounded-2xl p-3" data-testid="upcoming-events-widget">
            <div className="flex items-center justify-between mb-2">
                <p className="text-xs uppercase tracking-widest text-neutral-400 font-semibold">
                    Upcoming events
                </p>
                <Link to="/events" className="text-[10px] text-[#FFFFFF] hover:text-[#CCCCCC]">
                    All →
                </Link>
            </div>
            {!items.length && <p className="text-xs text-neutral-500 italic">Nothing scheduled</p>}
            <div className="space-y-1.5">
                {items.map((e) => (
                    <Link
                        key={e.id}
                        to={`/events/${e.slug || e.id}`}
                        className="flex items-center gap-2 p-1.5 rounded-lg hover:bg-white/5 transition-colors"
                        data-testid={`upcoming-evt-${e.slug || e.id}`}
                    >
                        {e.status === "live" ? (
                            <Radio size={12} className="text-[#FAFAFA] animate-pulse flex-shrink-0" />
                        ) : (
                            <Calendar size={12} className="text-[#FFFFFF] flex-shrink-0" />
                        )}
                        <div className="min-w-0 flex-1">
                            <p className="text-xs text-neutral-200 truncate">{e.title}</p>
                            <p className="text-[10px] text-neutral-500">
                                {new Date(e.scheduled_start).toLocaleString([], { month: "short", day: "numeric", hour: "2-digit", minute: "2-digit" })} · @{e.host_username}
                            </p>
                        </div>
                    </Link>
                ))}
            </div>
        </div>
    );
}
